<template>

    <ul class="ui grid centered container segments dimmable" id="container" v-show="productsList.length > 0">
      <!--<div class="ui inverted dimmer transition hidden">
        <div class="ui text loader">Loading</div>
      </div>-->
      <li class="sixteen wide column ui segment grid" v-for=" product in productsList ">
            <a class="ui left corner label mobile below being link light-yellow removebtn"  @click="removeSelectedProduct(product.id)">
                <i class="trash icon"></i> 
            </a>
            <div class="row">
                <div class="two wide column mobile below hidden">
                    <button class="ui big icon button light-yellow removebtn" title="CHECK_REMOVE" @click="removeSelectedProduct(product.id)">
                        <i class="trash outline icon"></i>
                    </button>
                </div>
                <div class="two wide column mobile below hidden">
                    <img class="ui centered medium image" :src=" product.image ">
                </div>
                <div class="sixteen wide mobile six wide tablet six wide computer column">
                    <h4 class="ui header">{{ product.name }}</h4>
                    <ul class="ui cell list" v-if="product.attrs || ( product.globalwifi && product.globalwifi.itineraryList )">
                        <template v-if="product.globalwifi && product.globalwifi.itineraryList" >
                            <li class="item">
                                高速流量：{{ product.globalwifi.flow_type }}
                            </li>
                            <li class="item" v-for="itinerary in product.globalwifi.itineraryList">
                                {{itinerary.countryName}}: {{itinerary.startTime}}~{{itinerary.endTime}}
                            </li>
                        </template>
<li class="item" v-for="attr in product.attrs" v-if="!thisOptionsValuesIdIsException(attr.options_values_id)">
    {{attr.products_options_name}}: <span v-html="attr.products_options_values_name"></span>
    <!--{{attr.products_options_values_name}}-->
</li>
</ul>
<a :href="product.link">{{ lang.say('BUY_DIFFERENT_SPECIFICATIONS') }}</a>
</div>
<div class="sixteen wide mobile two wide tablet two wide computer column ui form">
    <div class="field" :class="{'error': shouldShoeQtyError(product) }">
        <div class="ui fluid input" v-show="product.quantity >= 10">
            <input type="number" :value="product.quantity" @change="updateModelQuantity($event, product.id)">
        </div>
        <select class="ui compact fluid dropdown" v-show="product.quantity < 10" :value="product.quantity" @change="updateModelQuantity($event, product.id)">
            <option v-for="num in 9" :value="num">
                {{num}}
            </option>
            <option value="10">10+</option>
        </select>
        <label v-show="shouldShoeQtyError(product)">{{ lang.say('ERROR_RENTAL_QUANTITY_INSUFFICIENT') }}</label>
    </div>
</div>
<div class="sixteen wide mobile four wide computer column right aligned">
    <div class="ui list">
        <div class="item" v-if="product.priceToShow.others">
            <div class="header">
                {{ lang.say('TEXT_RENTAL_OTHERS_FEE') }}
            </div>
            {{product.priceToShow.others}}
        </div>
        <div class="item" v-if="product.priceToShow.desposit">
            <div class="header">
                {{ lang.say('TEXT_RENTAL_DEPOSIT') }}
            </div>
            {{product.priceToShow.desposit}}
        </div>
        <div class="item" v-if="product.priceToShow.setting_charge">
            <div class="header">
                {{ lang.say('TEXT_RENTAL_SETTING_FEE') }}
            </div>
            {{product.priceToShow.setting_charge}}
        </div>
        <div class="item" v-if="product.priceToShow.daily_rate">
            <div class="header">
                {{ lang.say('TEXT_RENTAL_DAILY_RATE') }}
            </div>
            {{product.rental.rental_days}} （{{ lang.say('TEXT_RENTAL_DAYS') }}）x {{product.priceToShow.daily_rate}} x {{product.quantity}} ≒ {{product.priceToShow.final_rate_price}}
        </div>
        <!-- 新增折扣表示 start -->
        <div class="item" v-if="product.priceToShow.discount">
            <div class="header">
                {{ lang.say('TEXT_RENTAL_DISCOUNT') }}
            </div>
            {{product.priceToShow.discount*100}}% off
        </div>
        <!-- 新增折扣表示 end -->
        <div class="item" v-if="product.priceToShow.total_daily_rate">
            <div class="header">
                {{ lang.say('TEXT_TOTAL_RENTAL_DAILY_RATE') }}
            </div>
            {{product.priceToShow.total_daily_rate}}
        </div>
        <div class="ui divider" v-if="typeof product.priceToShow === 'object'"></div>
        <div class="item" v-if=" typeof product.priceToShow === 'object' ">
            <span class="price">
                                {{product.priceToShow.final_price}}
                            </span>
        </div>
        <div class="item" v-if=" typeof product.priceToShow === 'string' ">
            <span class="price">
                                {{product.priceToShow}}
                            </span>
        </div>
    </div>
</div>
</div>
</li>
</ul>

</template>

<script>
    import util from '../util';
    import lang from '../lang';

    export default {
        data() {
            return {
                lang
            }
        },
        props: ['products-list'],
        methods: {

            shouldShoeQtyError(product) {
                if (!!product.flagForQuantityError) return true;
                if ((product.type == 'rental' || product.type == 'globalwifi') && product.quantity > product.stock) return true;
                return false;
            },

            thisOptionsValuesIdIsException(optionsValuesId) {
                return ~[util.PRODUCTS_OPTIONS_VALUE_GLOBALWIFI_ID].indexOf(optionsValuesId);
            },

            removeSelectedProduct(products_id) {
                this.$emit('removeSelectedProduct', products_id);
            },

            //we use this func to sync quantity of product,
            //because there seems a bug in vue.js with input type='number'
            updateModelQuantity(ev, products_id) {
                let num = Number(ev.target.value);
                num = num !== num ? 1 : num;
                this.updateQuantity(products_id, num);
            },

            updateQuantity(products_id, qty) {
                this.$emit('updateQuantity', products_id, qty);
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// ProductsList.vue?b5f875fe